import type { DataContainer } from "@otto-ec/tracking-bct";
import { ActivationStatus, type Detailview } from "../Detailview";
import { ActivationResponseType } from "utils/activation";

export type TrackingFeatureStatus = "loaded" | "clicked" | "hidden" | "visible";
type TrackingEventAction = "add" | "open" | "close" | "change" | "scroll" | "swipe" | "click";

export interface TrackingEvent {
	readonly name: TrackingEventAction;
	readonly features: (TrackingFeature | TrackingFeatureChild)[];
}

export interface TrackingFeature {
	readonly id: string;
	readonly name: string;
	readonly status: TrackingFeatureStatus;
	readonly labels: DataContainer;
}

export interface TrackingFeatureChild {
	readonly id: string;
	readonly name: string;
	readonly status: TrackingFeatureStatus;
	readonly labels: DataContainer;
	readonly parentId: string;
}

export interface TrackingActivationResponse {
	type: ActivationResponseType;
	delay: number;
}

export function createTrackingEvent(action: TrackingEventAction, trackingPayload: (TrackingFeature | TrackingFeatureChild)[]): TrackingEvent {
	return { name: action, features: trackingPayload };
}

const PROMO_FEATURE_LABELS: DataContainer = {
	promo_Feature: ["true"],
};

export function createTrackingEventPayload(benefit: Detailview, status: TrackingFeatureStatus, response?: TrackingActivationResponse): (TrackingFeature | TrackingFeatureChild)[] {
	const responseType = response?.type;
	const parentId = `FT9-benefit-detailview-${benefit.variationId}`;

	const detailviewTrackingPayload: TrackingFeature = {
		id: parentId,
		name: "BenefitDetailview",
		status: status,
		labels: PROMO_FEATURE_LABELS,
	};

	const labels = benefit.tracking.labels;

	if (responseType === ActivationResponseType.Error || responseType === ActivationResponseType.Conflict) {
		labels.benefit_Activation = ["error"];
	} else if (responseType === ActivationResponseType.Activated || benefit.activationStatus === ActivationStatus.ACTIVATED) {
		labels.benefit_Activation = ["on"];
	} else {
		labels.benefit_Activation = ["off"];
	}

	if (status === "clicked" && benefit.isAppOnly) {
		labels.benefit_AppOnlyClick = ["true"];
	}

	if (responseType === ActivationResponseType.Activated) {
		labels.benefit_TimeUntilActivation = [`${response?.delay}`];
	}

	const benefitTrackingPayload: TrackingFeatureChild = {
		id: `${benefit.tracking.id}-${benefit.variationId}`,
		name: benefit.tracking.name,
		status: status,
		labels: labels,
		parentId: parentId,
	};

	return [detailviewTrackingPayload, benefitTrackingPayload];
}
